import Vue from 'vue'
import App from './App.vue'
//引入store
import store from './store'

import 'normalize.css'
import './assets/styles/theme.css'
// import gdp from 'gio-webjs-sdk/dist/gdp-full';

/**
 * GrowingIO Analytics WebJS SDK version 4
 * Copyright 2015-2023 GrowingIO, Inc. More info available at http://www.growingio.com
 */
// gdp('init', process.env.VUE_APP_GIO_ACCOUNT_ID, process.env.VUE_APP_GIO_DATASOURCE_ID, {
// 	host: process.env.VUE_APP_GIO_HOST,
// 	version: '1.0.0',
// 	compress:'true',
// 	scheme: 'https',
// 	debug: true,
// 	dataCollect: true
// });

Vue.config.productionTip = false

import {Option, Cascader, Select, MessageBox, Dropdown, DropdownMenu, DropdownItem,Card,Tabs,Button,Row,Col,Dialog,Carousel,Icon,Popconfirm,CarouselItem,TabPane,Popover,Image,Container,Backtop,Result } from 'element-ui'

Vue.use(Option)
Vue.use(Cascader)
Vue.use(Select)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Card)
Vue.use(Tabs)
Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Dialog)
Vue.use(Carousel)
Vue.use(Icon)
Vue.use(Popconfirm)
Vue.use(CarouselItem)
Vue.use(TabPane)
Vue.use(Popover)
Vue.use(Image)
Vue.use(Container)
Vue.use(Backtop)
Vue.use(Result)
Vue.prototype.$alert = MessageBox.alert;

import VideoPlayer from 'vue-video-player'
//引入样式
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'
//使用组件
Vue.use(VideoPlayer)

new Vue({
	render: h => h(App),
	store,
}).$mount('#app')
